import { Injectable } from '@angular/core';
import flagsmith from '@flagsmith/flagsmith';
import { environment } from 'src/environments/environment';

export enum FlagsKeys {
  pollingInterval = 'polling_interval',
  doubleGisNewTiles = 'two_gis_new_tiles',
}

export interface FlagValueMap {
  [FlagsKeys.pollingInterval]: unknown;
  [FlagsKeys.doubleGisNewTiles]: boolean;
}

export type FlagValue<T extends FlagsKeys> = T extends keyof FlagValueMap
  ? FlagValueMap[T]
  : string;

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  /**
   * Инициализирует Flagsmith. Вызывается через provideAppInitializer в AppModule.
   */
  init(): Promise<void> {
    return flagsmith
      .init({
        environmentID: environment.flagsmithEnvironmentId,
        api: environment.flagsmithApiUrl,
      })
      .catch((error) => {
        console.warn(
          'Flagsmith: не удалось инициализировать, функциональность флагов отключена.',
          error,
        );
      });
  }

  refreshFlags(): Promise<void> {
    return flagsmith.getFlags().catch((error) => {
      console.warn(
        'Flagsmith: не удалось получить флаги, используются последние известные значения.',
        error,
      );
    });
  }

  isEnabled(flag: FlagsKeys): boolean {
    return flagsmith.hasFeature(flag);
  }

  getValue<T extends FlagsKeys>(flag: T): FlagValue<T> {
    return flagsmith.getValue(flag) as FlagValue<T>;
  }
}
